export default __webpack_public_path__ + "static/media/bottlingRuns.0057d277.jpg";